<template>
    <v-btn v-if="!isGuest"
           ref="scopes-button"
           v-tippy
           content="Scopes"
           :disabled="!canUseScopes || !image"
           @click="onClick"
    >
        <v-icon class="material-icons">equalizer</v-icon>
    </v-btn>
</template>

<script>
import CanMixin from "@/mixins/CanMixin";
import { mapGetters, mapState } from "vuex";

export default {
    mixins: [CanMixin],
    computed: {
        ...mapState('Projects', ['image']),
        ...mapState('Scopes', ['scopesEnabled']),
        ...mapGetters('User', ['isGuest']),
    },
    mounted() {
        this.$root.$refs.scopesButton = this.$refs["scopes-button"];
    },
    methods: {
        onClick() {
            this.scopesEnabled ? lutify.hideScopes() : lutify.showScopes();
        },
    }
}
</script>